export namespace IBus {
  export enum AppActions {
    Menu = 'app-menu',
  }

  export const AppMenuAction = {
    Display: `${AppActions.Menu}:display`,
    Close: `${AppActions.Menu}:close`,
  };
}
